import { render, staticRenderFns } from "./newOrderFooter.vue?vue&type=template&id=5b616caa&scoped=true&"
import script from "./newOrderFooter.vue?vue&type=script&lang=js&"
export * from "./newOrderFooter.vue?vue&type=script&lang=js&"
import style0 from "./newOrderFooter.vue?vue&type=style&index=0&id=5b616caa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b616caa",
  null
  
)

export default component.exports